export default __webpack_public_path__ + "static/media/team.8d95bb75.svg";